import React from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            width: '100%',
            height: '60px',
        },
    },
}))

const ColorButton = withStyles((theme) => ({
    root: {
        color: '#80491c',
        borderRadius: '10px',
        backgroundColor: 'transparent',
        border: '1px solid #80491c',
        transition: '200ms all ease-in-out',
        boxShadow: 'none',

        '&:hover': {
            backgroundColor: '#80491c',
            color: '#fff',
        },
    },
}))(Button)

const TertiaryButton = (props) => {
    const classes = useStyles()

    return (
        <div className={`${classes.root} ${props.btnSize} tertButton`}>
            <ColorButton
                variant="contained"
                color="primary"
                id={props.id}
                onClick={props.onClick}
                type={props.type}
            >
                {props.iconLeft}
                {props.label}
                {props.children}
            </ColorButton>
        </div>
    )
}

export default TertiaryButton
